module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "page",
    staticClass: "page-country"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "page-country-left"
  }, [_c('a', {
    staticClass: "back-link",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.toMap($event)
      }
    }
  }, [_c('p', [_vm._v("Вернуться к карте мира")])]), _vm._v(" "), _vm._l((_vm.countries), function(country) {
    return (country.name == _vm.routeName) ? _c('div', {
      staticClass: "page-country-left-bg",
      class: {
        'close-map': _vm.closeMapHead
      }
    }, [_c('div', {
      staticClass: "mobile-country-inner"
    }, [(_vm.closeMapHead && _vm.$root.isMobile) ? _c('div', {
      staticClass: "map-img-background"
    }) : _vm._e(), _vm._v(" "), _c('img', {
      staticClass: "map-img",
      class: {
        'img-israel': _vm.countries[_vm.routeName].name == 'israel'
      },
      attrs: {
        "src": _vm.countries[_vm.routeName].img,
        "alt": ""
      }
    }), _vm._v(" "), (_vm.$root.isMobile) ? _c('div', {
      staticClass: "mobile-dots"
    }, _vm._l((country.items), function(places, index) {
      return _c('a', {
        staticClass: "dot-places",
        style: (country.items[index].position_mobile),
        attrs: {
          "href": "#"
        },
        on: {
          "click": function($event) {
            $event.preventDefault();
            _vm.placesClickMobile(index, places.city)
          }
        }
      }, [_c('dot', {
        staticClass: "dot"
      })], 1)
    })) : _vm._e()]), _vm._v(" "), _vm._l((country.items), function(places, index) {
      return (!_vm.$root.isMobile) ? _c('a', {
        staticClass: "dot-places",
        style: (country.items[index].position),
        attrs: {
          "href": "#"
        },
        on: {
          "click": function($event) {
            $event.preventDefault();
            _vm.placesClick(index, places.city)
          }
        }
      }, [_c('dot', {
        staticClass: "dot"
      })], 1) : _vm._e()
    }), _vm._v(" "), (_vm.$root.isMobile) ? _c('a', {
      staticClass: "map-close",
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.closeMap($event)
        }
      }
    }, [_c('close'), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.closeMapHead ? 'Открыть' : 'Закрыть') + " тепловую карту")])], 1) : _vm._e()], 2) : _vm._e()
  })], 2), _vm._v(" "), _vm._l((_vm.countries), function(country, index) {
    return (country.name == _vm.routeName) ? _c('div', {
      staticClass: "page-country-right"
    }, [_c('div', {
      staticClass: "country-slider"
    }, [_c('div', {
      staticClass: "image-top-box"
    }, [_c('div', {
      staticClass: "image-top-main"
    }, [_c('img', {
      attrs: {
        "src": _vm.countries[_vm.routeName].items[_vm.currentIndex].img,
        "alt": ""
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "buttons-inner"
    }, [_c('div', {
      staticClass: "button-left",
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.prevPlace($event)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": "/static/images/country/arrow.png",
        "alt": ""
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "button-right",
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.nextPlace($event)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": "/static/images/country/arrow.png",
        "alt": ""
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "image-top-text"
    }, [_c('span', [_vm._v(_vm._s(country.title) + " | " + _vm._s(_vm.countries[_vm.routeName].items[_vm.currentIndex].city))]), _vm._v(" "), _c('h2', [_vm._v(_vm._s(country.items[_vm.currentIndex].name))]), _vm._v(" "), _c('p', {
      staticClass: "main-text"
    }, [_vm._v(_vm._s(country.items[_vm.currentIndex].text))]), _vm._v(" "), _c('p', {
      staticClass: "description"
    }, [_vm._v(_vm._s(country.items[_vm.currentIndex].description))])])]), _vm._v(" "), _c('div', {
      staticClass: "image-bottom-box"
    }, [_c('h3', [_vm._v("Хочешь сделать фото из необычного места?")]), _vm._v(" "), _c('p', {
      staticClass: "bottom-text"
    }, [_vm._v("Смотри места, которые мы подобрали:")]), _vm._v(" "), _c('div', {
      staticClass: "items"
    }, _vm._l((country.items), function(places, index) {
      return _c('div', {
        key: index,
        staticClass: "item"
      }, [_c('a', {
        attrs: {
          "href": "#"
        },
        on: {
          "click": function($event) {
            $event.preventDefault();
            _vm.placesClickMore(index, places.city)
          }
        }
      }, [(!_vm.$root.isMobile) ? _c('img', {
        attrs: {
          "src": places.img,
          "alt": ""
        }
      }) : _c('img', {
        attrs: {
          "src": places.img_mobile,
          "alt": ""
        }
      })]), _vm._v(" "), _c('h4', [_vm._v(_vm._s(places.name))]), _vm._v(" "), _c('a', {
        staticClass: "btn-more",
        attrs: {
          "href": "#"
        },
        on: {
          "click": function($event) {
            $event.preventDefault();
            _vm.placesClickMore(index, places.city)
          }
        }
      }, [_vm._v("Подробнее")])])
    })), _vm._v(" "), _c('div', {
      staticClass: "snapshot-box"
    }, [_c('h5', [_vm._v("Снимки в режиме 24/7")]), _vm._v(" "), _c('p', [_vm._v("Где бы ты не был, с роумингом от МегаФона ты можешь не думать\n                            о ценах на роуминг. Фотографируй все что хочешь, выкладывай в сеть, делись своими находками с друзьями, и продолжай искать самые фотогеничные места мира. Ведь МегаФон предлагает услуги связи\n                            по домашним ценам в путешествиях по миру.")]), _vm._v(" "), _c('span', [_vm._v("Стоимость операции - 299 рублей в сутки")]), _vm._v(" "), _c('a', {
      staticClass: "btn btn-connect",
      attrs: {
        "target": "_blank",
        "href": "https://www.megafon.ru/go/roaming_goodbye?utm_source=afisha&utm_campaign=fed_flight_www-b2c_afisha-special-project-roaming-goodbye-2-jul-2018_rf&utm_medium=ag-media_media_promo-block_text_cpc__&utm_content=&utm_term"
      },
      on: {
        "click": function($event) {
          _vm.gaSend('Button connect')
        }
      }
    }, [_vm._v("Подключить")])])])])]) : _vm._e()
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-48f37a85","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/Country.vue
// module id = 504
// module chunks = 1